import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../lib/api';
import { toast } from 'sonner';

export default function AdminAuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processGoogleAuth = async () => {
      const hash = window.location.hash;
      const sessionIdMatch = hash.match(/session_id=([^&]+)/);

      if (!sessionIdMatch) {
        toast.error('Error de autenticacion: sesion no encontrada');
        navigate('/admin/login', { replace: true });
        return;
      }

      const sessionId = sessionIdMatch[1];

      try {
        const response = await api.get(`/auth/session?session_id=${sessionId}`);
        toast.success(`Bienvenido, ${response.data.name || 'Superadmin'}!`);
        navigate('/admin/dashboard', { replace: true });
      } catch (error) {
        const detail = error.response?.data?.detail || 'Error al autenticar con Google';
        toast.error(detail);
        navigate('/admin/login', { replace: true });
      }
    };

    processGoogleAuth();
  }, [navigate]);

  return (
    <div className="min-h-screen bg-[#1A1A1A] flex items-center justify-center">
      <div className="text-center">
        <div className="w-16 h-16 border-4 border-[#F5A623] border-t-transparent rounded-full animate-spin mx-auto mb-6"></div>
        <p className="text-white text-xl font-semibold">Autenticando con Google...</p>
        <p className="text-[#666666] mt-2">Por favor espera un momento</p>
      </div>
    </div>
  );
}
